import React from 'react';
import VerifyIconSVG from '../../assets/icons/svg/VerifyIconSVG';

const AccountVerification = ({ onClick }) => {
  return (
    <div style={styles.container}>
      <div style={styles.wrapper} onClick={onClick}>
        <div style={styles.iconBox}>
          <VerifyIconSVG />
        </div>
        <div style={styles.textBox}>
          <div style={styles.title}>Tvoj nalog je u postupku provere.</div>
          <div style={styles.description}>
            Naša administrativna služba će te pozvati u roku od dva radna dana i nakon toga počinješ sa prodajom!
          </div>
        </div>
      </div>

      <div style={styles.infoBox}>
        <div style={styles.infoTitle}>Zašto proveravamo svakog partnera?</div>
        <div style={styles.infoText}>
          Prilikom registracije novog partnera na platformi, sistem automatski vrši verifikaciju unetog broja telefona i email adrese. 
          Korisnik dobija jednokratni kod putem SMS-a i emaila, koji mora uneti u aplikaciju kako bi potvrdio identitet. 
          Ukoliko verifikacija ne uspe nakon nekoliko pokušaja, nalog se privremeno blokira, a partner može zatražiti ručnu proveru od strane administratora. 
          Ovaj proces osigurava da samo provereni i pouzdani prodavci učestvuju u prodaji.
        </div>
      </div>
    </div>
  );
};

export default AccountVerification;

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: '50px',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '20px',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '12px',
    borderRadius: '6px',
    width: '430px',
    gap: '20px',
    border: '2px solid rgba(91, 33, 182, 1)',
    backgroundColor: 'rgba(245, 245, 244, 1)',
    minHeight: '320px', 
  },
  iconBox: {
    width: '195px',
    height: '160px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '20px',
    marginBottom: '20px',
  },
  textBox: {
    width: '100%',
    textAlign: 'left',
    padding: '0',
  },
  title: {
    color: 'rgba(91, 33, 182, 1)',
    fontSize: '20px',
    fontWeight: '700',
    letterSpacing: '0.2px',
    textAlign: 'left',
    lineHeight: '20px',
    marginBottom: '8px',
  },
  description: {
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: '16px',
    fontWeight: '400',
    letterSpacing: '0px',
    textAlign: 'left',
    lineHeight: '24px',
  },
  infoBox: {
    maxWidth: '580px',
    borderRadius: '8px',
    padding: '20px',
    marginTop: '40px',
  },
  infoTitle: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '20px',
    fontWeight: 600,
    letterSpacing: '0.15px',
    textAlign: 'left',
    lineHeight: '32px',
    marginBottom: '12px',
  },
  infoText: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '16px',
    fontWeight: 400,
    textAlign: 'left',
    lineHeight: '24px',
  },
};
